module.exports = __webpack_public_path__ + "img/frame (204).fe103c2a.jpg";